export const UserEventInfo = {
    title : "My Events",
    URL : '/user/events',
    noEventsMessage : "You don't have any events yet, would you like to add one?",
    noEventsLink : "/events",
    noEventsTitleLink : "Create new Event",

}